import { IRootState } from '../../../store'
import { ICrewState } from '../store/crew.types'

export const getCrewSelector = (state: IRootState): ICrewState => state.crew
